<template>
  <PopupRouterView :showLeftIcon="true" label="Mobile Device Input"
                   okTitle="Save"
                   cancelTitle="Cancel"
                   entityName="mobiledevice"
                   :documentId="mainRecordId"
                   @saveMethod="saveAction"
                   @hideMethod="onHidden"
                   ref="mobileDeviceInput">


    <b-card header="Mobile Device" class="mb-3 card-max-width">
      <b-row>
        <b-col cols="12" lg="6">
          <app-input-textbox id="fieldset-name" label-cols-lg="12" label="Name" label-for="input-name" size="sm"
                             :model.sync="model.name" :isRequired="true" :state="validateState('name')"
                             :errorMessage="getErrorMessage(errorMessage.name, 'name')" :isUpdatable="null"/>
          <app-input-textbox id="fieldset-identifier-code" label-cols-lg="12" label="Mobile Identifier Code"
                             label-for="input-identifier-code" size="sm" :model.sync="model.identifierCode"
                             :isRequired="true" :state="validateState('identifierCode')"
                             :errorMessage="getErrorMessage(errorMessage.identifierCode, 'identifierCode')"
                             :isUpdatable="null"/>
          <app-input-combobox-autocomplete :options="printerInformations" optionsLabel="name" optionsKey="id"
                                           label-cols-lg="12" label="Bound To Printer" id="fieldset-bound-to-printer"
                                           size="sm" :model.sync="model.boundToPrinterId"
                                           :selected="model.boundToPrinter != null ? model.boundToPrinter.name : ''"
                                           @input="getPrinterInformations" :isUpdatable="null"
                                           :isSelectMethodExists="true" @onSelectMethod="setSelectedBoundToPrinter"/>
        </b-col>
        <b-col cols="12" lg="6">
        </b-col>

      </b-row>
    </b-card>


    <b-overlay :show="isBusy" no-wrap></b-overlay>
  </PopupRouterView>
</template>
<script>
import axios from 'axios';
import {validationMixin} from "vuelidate";
import {required, minLength} from "vuelidate/lib/validators";
import MobileDevice from '@/models/MobileDevice/MobileDevice';
import MobileDeviceList from '@/models/MobileDevice/MobileDeviceList';
import MobileDeviceFilter from '@/filters/MobileDevice/MobileDeviceFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PrinterInformation from '@/models/PrinterInformation/PrinterInformation';
import PrinterInformationFilter from '@/filters/PrinterInformation/PrinterInformationFilter';
import PopupRouterView from '@/components/PopupRouterView';

export default {
  components: {
    AppInputTextbox,
    AppInputComboboxAutocomplete,
    PopupRouterView,
  },
  mixins: [validationMixin],
  validations: {
    model: {
      name: {required},
      identifierCode: {required},
    },
  },
  data() {
    return {
      errorMessage: {
        name: {required: "Name is Required."},
        identifierCode: {required: "Mobile Identifier Code is Required."},
      },
      datas: Array(),
      selectAll: false,
      sortBy: '',
      sortDesc: '',
      pagingOptions: [
        {value: '10', text: '10', selected: true},
        {value: '25', text: '25'},
        {value: '50', text: '50'},
        {value: '100', text: '100'},
      ],
      busy: false,
      isBusy: false,
      isDataLoading: false,
      selected: '',
      pageSizeOptions: 10,
      pageIndex: 0,
      sortingBy: Array(),
      modelId: null,
      model: {},
      filterMobileDevice: null,
      currentMobileDevicePage: 1,
      mobileDevicePageSize: 10,
      sortByMobileDevice: '',
      sortDescMobileDevice: '',
      printerInformations: [],
      boundToPrinters: [],
      isBoundToPrinterComboLoading: false,
      isShowPopupConfirmation: false,
      isDataCommited: false,
      mainRecordId: '',
      isPrinterInformationComboLoading: false,
    }
  },
  methods: {
    showPopupWithMessage: async function (message) {
      const msg = this.$createElement;
      let msgNode = '';
      let result = false;
      msgNode = msg('div', {domProps: {innerHTML: '<p>' + message + '</p>'}})
      await this.$bvModal.msgBoxConfirm([msgNode], {
        title: 'Alert',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        cancelVariant: 'secondary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(e => {
        if (e) {
          result = true;
        }
      });
      return result;
    },
    getMobileDevice: async function (id) {
      this.isBusy = true;
      return MobileDevice.getData(this, id).then(result => {
        this.model = result;
        this.mainRecordId = String(result.mainRecordId);
        let promises = Array();


        Promise.all(promises).then((results) => {
          this.isBusy = false;
        });
      }).catch(error => {
        this.isBusy = false;
      });
    },
    downloadData() {
      this.isDownloadMobileDevice = true;
      this.filterMobileDevice.id = this.modelId;
      MobileDevice.downloadDataDetail(this, this.filterMobileDevice).then(result => {
        this.isDownloadMobileDevice = false;
      }).catch(error => {
        this.isDownloadMobileDevice = false;
      })
    },
    getMobileDevices: async function (input) {
      let filter = new MobileDeviceFilter();
      if (input != undefined) {
        filter.Name = input;
      }
      this.isMobileDeviceComboLoading = true;
      MobileDevice.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.mobileDevices = result.data
            }
            this.isMobileDeviceComboLoading = false;
          })
          .catch(error => {
          });
    },
    getPrinterInformations: async function (input) {
      let filter = new PrinterInformationFilter();
      if (input != undefined) {
        filter.name = input;
      }
      PrinterInformation.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.printerInformations = result.data
            }
          })
          .catch(error => {
          });
    },
    setSelectedBoundToPrinter(item) {
      if (item == undefined || item == null) {
        this.model.boundToPrinterId = null;
        this.model.boundToPrinter = null;
      } else {
        this.model.boundToPrinterId = item.id;
        this.model.boundToPrinter = item;
      }
      this.$forceUpdate();
      this.updateData();
    },
    validateState(name) {
      if (!this.$v.model[name]) return null;
      const {$dirty, $error} = this.$v.model[name];
      return $dirty ? !$error : null;
    },
    getErrorMessage(message, name) {
      if (!this.$v.model[name]) return "";
      if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
        if (message.required) return message.required;
      }
    },
    handleScroll() {
      this.$refs.mobileDeviceInput.scrollTop = 0;
    },
    saveAction(modalEvent) {
      modalEvent.preventDefault();
      this.handleScroll();
      let id = this.$route.params.id;
      this.$v.model.$touch();
      if (this.$v.model.$anyError) {
        return;
      } else {
        this.isBusy = true;
        let id = this.modelId;
        let model = this.model;

        let promises = Array();

        Promise.all(promises).then((results) => {
          if (id != '' && id != null && id != undefined) {
            MobileDevice.updateData(this, model, id).then(result => {
              this.isDataCommited = true;
              if (result) {
                this.$router.push({name: 'mobiledeviceindex'});
              }
              this.isBusy = false;
            }).catch(error => {
              this.isBusy = false;
            });
          } else {
            MobileDevice.insertData(this, model).then(result => {
              this.isDataCommited = true;
              if (result) {
                this.$router.push({name: 'mobiledeviceindex'});
              }
              this.isBusy = false;
            }).catch(error => {
              this.isBusy = false;
            });
          }
        });
      }
    },
    updateData() {
      let id = this.modelId;
      let model = this.model;
      let promises = Array();

      Promise.all(promises).then((results) => {
        if (id != '' && id != null && id != undefined) {
          MobileDevice.updateData(this, model, id)
              .catch((error) => {
                this.getMobileDevice(id);
              });
        }
      });
    },
    onHidden() {
      this.getMobileDevices();
    },
    resetModal(modalType) {
      this.showPopupCopyData = false;
      this.isShowPopupConfirmation = false;
    },
    displayFilter() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 768) {
      }
    },
  },
  beforeMount() {
    this.filterMobileDevice = new MobileDeviceFilter();
    //this.getPrinterInformations();
  },
  async mounted() 
  {
    let id = this.$route.params.id;
    let copyData = this.$route.params.copydata;
    if (id != '' && id != null && id != undefined) {
      if (copyData != null && copyData != undefined) {
        await this.getMobileDevice(id);
      } else {
        this.modelId = id;
        await this.getMobileDevice(id);
      }
    }
    
    this.$nextTick(() => {
      window.addEventListener('resize', this.displayFilter);
      this.displayFilter();
    });
  },
  computed: {
    isAllowSaveDraft: {
      get: function () {
        return true;
      }
    }
  },
  watch: {},
}
</script>
